<template>
    <div :class="cardClass">
        <div class="flex justify-between w-full">
            <router-link
                :to="`/lounges/search?airport=${airport.code}`"
                class="rounded-lg justify-center items-center gap-0.5 flex"
            >
                <div :class="codeClass">
                    {{ splitCode[0] }}
                </div>
                <div :class="codeClass">
                    {{ splitCode[1] }}
                </div>
                <div :class="codeClass">
                    {{ splitCode[2] }}
                </div>
            </router-link>
            <div
                class="w-5 h-5 justify-center items-center flex"
                v-if="!hideFavoriteButton"
            >
                <FavButton
                    :isFavorite="isFavoriteAirport"
                    @toggleFavorite="handleToggleFavorite"
                />
            </div>
        </div>
        <router-link
            :to="`/lounges/search?airport=${airport.code}`"
            class="self-stretch pt-3 flex-col justify-start items-start gap-1 flex"
        >
            <div :class="headerClass">
                {{ airportName }}
            </div>
            <div
                class="self-stretch text-slate-500 text-sm font-normal leading-tight text-ellipsis whitespace-nowrap overflow-hidden text-left"
            >
                {{ airportAddress }}
            </div>
        </router-link>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useLoungesStore } from '@/store/lounges';
import FavButton from '@/components/ui/fav-button/fav-button.vue';
const loungesStore = useLoungesStore();
const { toggleFavorite } = loungesStore;
const props = defineProps({
    airport: { required: true, type: Object },
    hideFavoriteButton: { type: Boolean, required: false, default: false },
    cardClass: {
        type: String,
        default:
            'h-28 flex-col justify-start items-start flex w-full sm:max-w-64 min-w-64 px-4 py-3 bg-white rounded-lg shadow',
    },
    size: {
        type: String,
        default: 'small',
    },
});
const isFavoriteAirport = ref(props.airport.favorite);
const splitCode = computed(() => {
    return props.airport.code.split('');
});

const airportName = computed(() => {
    return props.airport.name.split('(')[0].trim();
});

const airportAddress = computed(() => {
    return props.airport.city + ', ' + props.airport.country;
});

const codeClass = computed(() => {
    switch (props.size) {
        case 'small':
            return 'w-6 p-1 bg-gradient-to-b from-slate-100 via-slate-200 to-slate-200 rounded justify-center items-center flex self-stretch text-center text-slate-600 text-base font-medium leading-normal';
        case 'large':
            return 'w-8 h-10 p-1 bg-gradient-to-b from-slate-100 via-slate-200 to-slate-200 rounded justify-center items-center flex self-stretch text-center text-slate-600 text-2xl font-medium leading-loose';
    }
});

const headerClass = computed(() => {
    switch (props.size) {
        case 'small':
            return 'self-stretch text-slate-800 text-sm font-medium  leading-tight text-ellipsis whitespace-nowrap overflow-hidden text-left';
        case 'large':
            return 'text-slate-800 text-xl font-medium leading-7';
    }
});

const handleToggleFavorite = async () => {
    if (!props.airport?.id) {
        console.error('No valid airport to favorite:', props.airport);
        return;
    }
    isFavoriteAirport.value = !isFavoriteAirport.value;

    const res = await toggleFavorite(props.airport, 'airport');
    if (!res || res.status !== 200) {
        isFavoriteAirport.value = !isFavoriteAirport.value;
    }
};
</script>
